export namespace BackupSeparator {
  export const snapshotVdd_LL_KeySeparator = '__';

  export function removeBackupSeparator(vddName: string): string {
    if (vddName && typeof vddName === 'string' && vddName.includes(snapshotVdd_LL_KeySeparator)) {
      vddName = vddName.split(snapshotVdd_LL_KeySeparator)[0];
    }

    return vddName;
  }

  export function addBackupSeparator(vddName: string, logicalLinkName: string): string {
    if (typeof vddName === 'string') {
      if (vddName && vddName.includes(snapshotVdd_LL_KeySeparator)) {
        return vddName;
      } else {
        return vddName + snapshotVdd_LL_KeySeparator + logicalLinkName;
      }
    } else {
      return vddName;
    }
  }
}
